var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 5.33337H9.33329C5.33329 5.33337 2.66663 7.33338 2.66663 12.0001V16.7467C2.66663 17.2401 3.17329 17.5468 3.61329 17.3468C4.91996 16.7467 6.42663 16.5201 8.01329 16.8001C11.52 17.4268 14.0933 20.6801 14 24.2401C13.9866 24.8001 13.9066 25.3468 13.76 25.8801C13.6533 26.2935 13.9866 26.6801 14.4133 26.6801H22.6666C26.6666 26.6801 29.3333 24.6801 29.3333 20.0134V12.0001C29.3333 7.33338 26.6666 5.33337 22.6666 5.33337ZM16 19.3334C14.16 19.3334 12.6666 17.8401 12.6666 16.0001C12.6666 14.1601 14.16 12.6667 16 12.6667C17.84 12.6667 19.3333 14.1601 19.3333 16.0001C19.3333 17.8401 17.84 19.3334 16 19.3334ZM25.6666 18.6668C25.6666 19.2134 25.2133 19.6668 24.6666 19.6668C24.12 19.6668 23.6666 19.2134 23.6666 18.6668V13.3334C23.6666 12.7867 24.12 12.3334 24.6666 12.3334C25.2133 12.3334 25.6666 12.7867 25.6666 13.3334V18.6668Z",
    fill: "#7D14FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 5.33337H9.33329C5.33329 5.33337 2.66663 7.33338 2.66663 12.0001V16.7467C2.66663 17.2401 3.17329 17.5468 3.61329 17.3468C4.91996 16.7467 6.42663 16.5201 8.01329 16.8001C11.52 17.4268 14.0933 20.6801 14 24.2401C13.9866 24.8001 13.9066 25.3468 13.76 25.8801C13.6533 26.2935 13.9866 26.6801 14.4133 26.6801H22.6666C26.6666 26.6801 29.3333 24.6801 29.3333 20.0134V12.0001C29.3333 7.33338 26.6666 5.33337 22.6666 5.33337ZM16 19.3334C14.16 19.3334 12.6666 17.8401 12.6666 16.0001C12.6666 14.1601 14.16 12.6667 16 12.6667C17.84 12.6667 19.3333 14.1601 19.3333 16.0001C19.3333 17.8401 17.84 19.3334 16 19.3334ZM25.6666 18.6668C25.6666 19.2134 25.2133 19.6668 24.6666 19.6668C24.12 19.6668 23.6666 19.2134 23.6666 18.6668V13.3334C23.6666 12.7867 24.12 12.3334 24.6666 12.3334C25.2133 12.3334 25.6666 12.7867 25.6666 13.3334V18.6668Z",
    fill: "url(#paint0_linear_2946_23097)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 18.6667C3.72004 18.6667 1.33337 21.0534 1.33337 24.0001C1.33337 25.0001 1.61337 25.9468 2.10671 26.7468C3.02671 28.2934 4.72004 29.3335 6.66671 29.3335C8.61337 29.3335 10.3067 28.2934 11.2267 26.7468C11.72 25.9468 12 25.0001 12 24.0001C12 21.0534 9.61337 18.6667 6.66671 18.6667ZM8.65337 24.9734H7.66671V26.0134C7.66671 26.5601 7.21337 27.0134 6.66671 27.0134C6.12004 27.0134 5.66671 26.5601 5.66671 26.0134V24.9734H4.68004C4.13337 24.9734 3.68004 24.5201 3.68004 23.9734C3.68004 23.4268 4.13337 22.9734 4.68004 22.9734H5.66671V22.0268C5.66671 21.4801 6.12004 21.0268 6.66671 21.0268C7.21337 21.0268 7.66671 21.4801 7.66671 22.0268V22.9734H8.65337C9.20004 22.9734 9.65337 23.4268 9.65337 23.9734C9.65337 24.5201 9.21337 24.9734 8.65337 24.9734Z",
    fill: "#7D14FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 18.6667C3.72004 18.6667 1.33337 21.0534 1.33337 24.0001C1.33337 25.0001 1.61337 25.9468 2.10671 26.7468C3.02671 28.2934 4.72004 29.3335 6.66671 29.3335C8.61337 29.3335 10.3067 28.2934 11.2267 26.7468C11.72 25.9468 12 25.0001 12 24.0001C12 21.0534 9.61337 18.6667 6.66671 18.6667ZM8.65337 24.9734H7.66671V26.0134C7.66671 26.5601 7.21337 27.0134 6.66671 27.0134C6.12004 27.0134 5.66671 26.5601 5.66671 26.0134V24.9734H4.68004C4.13337 24.9734 3.68004 24.5201 3.68004 23.9734C3.68004 23.4268 4.13337 22.9734 4.68004 22.9734H5.66671V22.0268C5.66671 21.4801 6.12004 21.0268 6.66671 21.0268C7.21337 21.0268 7.66671 21.4801 7.66671 22.0268V22.9734H8.65337C9.20004 22.9734 9.65337 23.4268 9.65337 23.9734C9.65337 24.5201 9.21337 24.9734 8.65337 24.9734Z",
    fill: "url(#paint1_linear_2946_23097)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2946_23097",
    x1: 2.66663,
    y1: 5.33337,
    x2: 23.4956,
    y2: 31.3532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2946_23097",
    x1: 1.33337,
    y1: 18.6667,
    x2: 12.0001,
    y2: 29.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyAdd);
export default __webpack_public_path__ + "static/media/money-add.8cc5eec9f34a8d0b421d7621bcb9238a.svg";
export { ForwardRef as ReactComponent };